import { Controller } from "@hotwired/stimulus"

// Whether the typed reference differs is the server's call alone, on the raw
// value: JS trim() drops U+00A0 where Ruby String#strip keeps it.
export default class extends Controller {
  static targets = ["dialog", "input", "confirm"]
  static values = { previewUrl: String }

  connect() {
    this.emptyPreview = this.frame()?.innerHTML ?? ""
  }

  open(event) {
    event?.preventDefault()
    this.inputTarget.value = ""
    this.validate()
    this.resetPreview()
    this.dialogTarget.showModal()
    this.inputTarget.focus()
  }

  close(event) {
    event?.preventDefault()
    this.dialogTarget.close()
  }

  backdropClick(event) {
    if (event.target === this.dialogTarget) this.close()
  }

  validate() {
    this.confirmTarget.disabled = !this.usable(this.reference())
  }

  check(event) {
    event?.preventDefault()
    const reference = this.reference()
    if (!this.usable(reference)) return

    const url = new URL(this.previewUrlValue, window.location.origin)
    url.searchParams.set("reference", reference)
    this.frame().src = url.toString()
  }

  // Clearing src alone leaves the previously fetched placement on screen, so a
  // reopened dialog would show an empty field beside someone else's placement.
  resetPreview() {
    const frame = this.frame()
    if (!frame) return

    frame.removeAttribute("src")
    frame.innerHTML = this.emptyPreview
  }

  frame() {
    return this.element.querySelector("turbo-frame#reference-replacement-preview")
  }

  reference() {
    return this.inputTarget.value
  }

  usable(reference) {
    return reference.trim() !== ""
  }
}
